module.exports = __webpack_public_path__ + "static/media/hyundai-go-drive.ca34a77c.jpg";